import { useQuery } from 'react-query';
import DashboardApiService from '@/modules/dashboard/services/DashboardApiService';
import { FilterFactory, TermFilter } from '@dofleini/query-builder';

export const usePaymentData = (filter, userId) => {
  if (userId)
    filter = FilterFactory.add(filter, new TermFilter({ field: 'owner', value: userId, objectId: true }));
  
  const { data, ...rest } = useQuery(
    ['payment-data', filter, userId],
    () => DashboardApiService.getPaymentData({ filters: filter }),
    { enabled: !!filter },
  );
  
  return {
    ...rest,
    data: data?.[0] || [],
  };
};

export const usePaymentByStatus = (filter, userId) => {
  if (userId)
    filter = FilterFactory.add(filter, new TermFilter({ field: 'owner', value: userId, objectId: true }));
  
  const { data, ...rest } = useQuery(
    ['payment-data-by-status', filter, userId],
    () => DashboardApiService.getPaymentByStatus({ filters: filter }),
    { enabled: !!filter },
  );
  
  return {
    ...rest,
    data: data || [],
  };
};
